let id = 0;

export function makeId() {
  return `muigui-${++id}`;
}
